//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formulaDetail } from "../../server/oldformula/";
import { mapMutations } from "vuex";
export default {
  name: "common_info",
  data() {
    return {
      formulaInfo: {},
      content: [],
      refList: [],
      id: "",
    };
  },
  components: {},
  created() {
    console.log("common_info");
    this.hideLoad();
    this.id = this.$route.query.id;
    this.getFormulaDetail();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
    async getFormulaDetail() {
      var params = {
        uuid: this.id,
      };
      try {
        const res = await formulaDetail(params);
        console.log(res,'公式介绍和说明');
        this.formulaInfo = res;
        if (this.formulaInfo.introExplain) {
          this.content = JSON.parse(this.formulaInfo.introExplain);
        }
        if (this.formulaInfo.referenceNew) {
          this.refList = JSON.parse(this.formulaInfo.referenceNew);
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/formulaComponent/commonInfo.vue